import { map } from "lodash";
import { IntakePetSectionQuestionModel } from ".";

export interface IIntakePetSection {
    intakePetSectionId: number;
    intakePetId: number;
    sectionId: number;
    name: string;
    displayName: string;
    sortOrder: number;
    questions: IntakePetSectionQuestionModel[];
    rowVersion: string;
}

export class IntakePetSection implements IIntakePetSection {
    intakePetSectionId: number;
    intakePetId: number;
    sectionId: number;
    name: string;
    displayName: string;
    sortOrder: number;
    questions: IntakePetSectionQuestionModel[] = [];
    rowVersion: string;

    constructor(params: Partial<IIntakePetSection> = {}) {
        const {
            intakePetSectionId = 0,
            intakePetId = 0,
            sectionId = 0,
            name = '',
            displayName = '',
            sortOrder = 0,
            questions = [] as Array<IntakePetSectionQuestionModel>,
            rowVersion = ''
        } = params;

        this.intakePetSectionId = intakePetSectionId;
        this.intakePetId = intakePetId;
        this.sectionId = sectionId;
        this.name = name;
        this.displayName = displayName;
        this.sortOrder = sortOrder;
        map(questions, (question) => { this.questions.push(new IntakePetSectionQuestionModel(question)); });
        this.rowVersion = rowVersion;
    }
}
